import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ObtentorVariedadVegetalComponent } from '../tramites/ica/obtentor-variedad-vegetal/obtentor-variedad-vegetal.component';
import { CompetenciaDeslealComponent } from './sic/competencia-desleal/competencia-desleal.component';
import { authGuard } from '../../services/guard/auth.guard';
import { ProteccionConsumidorComponent } from './sic/proteccion-al-consumidor/proteccion-consumidor/proteccion-consumidor.component';
import { CrearDemandaJurisdiccionalComponent } from './supersalud/crear-demanda-jurisdiccional/crear-demanda-jurisdiccional.component';
import { SeleccionEntidadComponent } from './seleccion-entidad/seleccion-entidad.component';
import { CreacionDndaComponent } from './creacion-dnda/creacion-dnda.component';
import { CreacionDimarComponent } from './creacion-dimar/creacion-dimar.component';
import { AsuntosMercantilesComponent } from './superintendecia-mercantiles/asuntos-mercantiles.component';
import { SupersociedadesRoiComponent } from './reorganizacion-ordinaria-insolvencia/supersociedades-roi/supersociedades-roi.component';
import {
  LiqJudicialSociedadComponent
} from "./supersociedades/liquidacion-judicial/liq-judicial-sociedad/liq-judicial-sociedad.component";
import {
  LiqJudicialTipoSolicitanteComponent
} from "./supersociedades/liquidacion-judicial/liq-judicial-tipo-solicitante/liq-judicial-tipo-solicitante.component";
import { ValidacionJudicialComponent } from './supersociedades-validacion-judicial/validacion-judicial/validacion-judicial.component';
import { SfcProConComponent } from './superfinanciera/sfc-procon/sfc-procon.component';

const routes: Routes = [
  {
    path: '',
    data: { breadcrumb: 'miga-pan.crear-expediente' },
    children: [
      {
        path: '',
        component: SeleccionEntidadComponent,
        data: { breadcrumb: 'miga-pan.seleccionar-entidad' },
      },
      {
        path: 'dnda',
        component: CreacionDndaComponent,
        data: { breadcrumb: 'miga-pan.dnda' },
      },
      {
        path: 'dimar',
        component: CreacionDimarComponent,
        data: { breadcrumb: 'miga-pan.dimar' },
      },
      {
        path: 'dimar/:idTramite',
        component: CreacionDimarComponent,
        data: { breadcrumb: 'miga-pan.dimar' },
      },
      {
        path: 'ica/obtentor-variedad-vegetal',
        component: ObtentorVariedadVegetalComponent,
        canActivate: [authGuard],
        data: { breadcrumb: 'miga-pan.obtentor-variedad-vegetal' },
      },
      {
        path: 'sic',
        data: { breadcrumb: 'miga-pan.sic' },
        children: [
          {
            path: 'competencia-desleal',
            component: CompetenciaDeslealComponent,
            canActivate: [authGuard],
            data: { breadcrumb: 'miga-pan.competencia-desleal' },
          },
          {
            path: 'proteccion-consumidor',
            component: ProteccionConsumidorComponent,
            canActivate: [authGuard],
            data: { breadcrumb: 'miga-pan.proteccion-consumidor' },
          },
        ],
      },
      {
        path: 'supersalud/crear-demanda',
        component: CrearDemandaJurisdiccionalComponent,
        canActivate: [authGuard],
        data: { breadcrumb: 'miga-pan.crear-demanda-jurisdiccional' },
      },
      {
        path: 'superfinanciera/proteccion-consumidor',
        component: SfcProConComponent,
        canActivate: [authGuard],
        data: { breadcrumb: 'miga-pan.proteccion-consumidor-superfinanciera' },
      },
      {
        path: 'supersociedades-mercantiles',
        component: AsuntosMercantilesComponent,
        canActivate: [authGuard],
        data: { breadcrumb: 'miga-pan.supersociedades-mercantiles' },
      },
      {
        path: 'sso/reorganizacion-judicial-insolvencia',
        component: SupersociedadesRoiComponent,
        canActivate: [authGuard],
        data: { breadcrumb: 'miga-pan.reorganizacion-judicial-insolvencia' },
      },
      {
        path: 'sso/liquidacion-judicial-insolvencia',
        component: LiqJudicialTipoSolicitanteComponent,
        canActivate: [authGuard],
        data: { breadcrumb: 'miga-pan.liquidacion-judicial-insolvencia' },
      },
      {
        path: 'sso/validacion-judicial-insolvencia',
        component: ValidacionJudicialComponent,
        canActivate: [authGuard],
        data: { breadcrumb: 'miga-pan.validacion-judicial-insolvencia' },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TramitesRoutingModule {}
